import styled from 'styled-components'

import { IconsQA } from 'shared/dataAttributes'

export const AffirmLogo = () => {
  return (
      <CustomSvg
        data-qa={IconsQA.AffirmIcon}
        width="48"
        height="32"
        viewBox="0 0 48 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.592593"
          y="0.592593"
          width="46.8148"
          height="30.8148"
          rx="1.40741"
          fill="white"
          stroke="#E7E7E7"
          stroke-width="1.18519"
        />
        <mask
          id="mask0_641_16404"
          maskUnits="userSpaceOnUse"
          x="7"
          y="9"
          width="34"
          height="14"
        >
          <path d="M40.7403 9.33337H7.32513V22.6667H40.7403V9.33337Z" fill="white" />
        </mask>
        <g mask="url(#mask0_641_16404)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.51632 21.5182C9.10307 21.5182 8.89254 21.3147 8.89254 20.9802C8.89254 20.3564 9.58806 20.1466 10.8567 20.0117C10.8567 20.8429 10.2945 21.5182 9.51243 21.5182H9.51632ZM10.0621 16.8437C9.15531 16.8437 8.11282 17.2702 7.54673 17.7217L8.06369 18.8133C8.51749 18.3977 9.25122 18.0422 9.91321 18.0422C10.5424 18.0422 10.8902 18.2527 10.8902 18.6768C10.8902 18.9614 10.6602 19.1057 10.2251 19.1626C8.59859 19.3731 7.32373 19.8223 7.32373 21.0753C7.32373 22.0687 8.03094 22.6698 9.13582 22.6698C9.9249 22.6698 10.6267 22.2316 10.9604 21.6562V22.5139H12.4309V18.9201C12.4309 17.4386 11.4025 16.8406 10.0629 16.8406L10.0621 16.8437Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.8214 17.0051V22.5069H26.3949V19.8558C26.3949 18.5965 27.1575 18.2262 27.6885 18.2262C27.9275 18.2243 28.1617 18.2935 28.3614 18.425L28.6491 16.9708C28.4261 16.8816 28.1874 16.8383 27.9473 16.8437C27.1388 16.8437 26.6304 17.2016 26.2951 17.9299V17.0051H24.8214Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.9411 16.8438C35.1091 16.8438 34.4869 17.335 34.1633 17.8091C33.8631 17.197 33.2277 16.8438 32.4635 16.8438C31.6323 16.8438 31.0561 17.3054 30.7902 17.8371V17.0052H29.2729V22.5069H30.8479V19.6742C30.8479 18.6605 31.3805 18.1701 31.8772 18.1701C32.3271 18.1701 32.7403 18.4609 32.7403 19.2118V22.5069H34.3123V19.6742C34.3123 18.6457 34.8316 18.1701 35.3516 18.1701C35.768 18.1701 36.2093 18.4726 36.2093 19.2009V22.5069H37.7813V18.7034C37.7813 17.4675 36.9493 16.8438 35.9442 16.8438"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.9921 17.0051H19.5668V16.446C19.5668 15.7178 19.9824 15.5104 20.3403 15.5104C20.5847 15.5136 20.8249 15.5736 21.0421 15.6858L21.527 14.5763C21.527 14.5763 21.035 14.255 20.1407 14.255C19.1356 14.255 17.9918 14.8219 17.9918 16.6004V17.0051H15.6097V16.446C15.6097 15.7178 16.0245 15.5104 16.3832 15.5104C16.6279 15.5104 16.869 15.5706 17.0849 15.6858L17.5699 14.5763C17.2806 14.4071 16.8152 14.255 16.1844 14.255C15.1793 14.255 14.0354 14.8219 14.0354 16.6004V17.0051H13.1247V18.2183H14.0378V22.5068H15.6097V18.2183H17.9949V22.5068H19.5668V18.2183H20.9921V17.0051Z"
            fill="black"
          />
          <path d="M23.5013 17.005H21.931V22.5044H23.5013V17.005Z" fill="black" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.9886 16.0701H23.527C24.4245 13.2483 27.4693 10.768 31.0904 10.768C35.4943 10.768 39.3001 14.1208 39.3001 19.3403C39.3136 20.4116 39.1663 21.479 38.8635 22.5068H40.3567L40.3715 22.4553C40.6231 21.4378 40.7472 20.3931 40.7411 19.345C40.7411 13.5243 36.4994 9.33484 31.0935 9.33484C26.8471 9.33484 23.0623 12.2822 21.9894 16.0717L21.9886 16.0701Z"
            fill="#4A4AF4"
          />
        </g>
      </CustomSvg>
  )
}

const CustomSvg = styled.svg`
  height: 32px;
  min-height: 32px;
  min-width: 48px;
  width: 48px;
`
